module.exports = __webpack_public_path__ + "img/default-product.7e1c0b22.png";